const route = {
	path: '/modules',
	name: 'accounting-modules',
	meta: {
		title: 'Lista de Módulos',
	},
	component: () => import('@/pages/modules/page-modules'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/modules.js